<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "serviceManage",
};
</script>

<style lang="less" scope>

</style>